import { Button, Icon, Modal } from '@oscar/theme';
import { ActionField, AsyncField, useFormContext } from '@oscar/form';
import './styles.scss';
import { APIS } from 'common/constants/endpoints';
import { useState } from 'react';
import { values } from 'lodash';
import moment from 'moment';
import { FORMAT_DATE } from 'common/constants';

export const ActivityLog = () => {
  const [showActivityLog, setShowActivityLog] = useState(false);
  const [activityLogData, setActivityLogData] = useState([]);
  const [formContext] = useFormContext();
  const id = formContext.selectors?.getInitalValue()?.id;

  const handleCancel = () => {
    setShowActivityLog(false);
  };

  const DateText = ({ value }: { value?: string }) => {
    return (
      <div className="modal-date">
        {moment(value).format(FORMAT_DATE.FULL_DATETIME_HOUR)}
      </div>
    );
  };

  const TitleText = ({ value }: { value?: string }) => {
    return <div className="modal-title">{value}</div>;
  };

  const AuthorText = ({ name, role }: { name?: string; role?: string }) => {
    return (
      <div className="modal-author">
        <span className="modal-sub-author">by</span>
        {`${name}`} ({`${role}`})
      </div>
    );
  };

  const TimeDuration = ({ value }: { value: any }) => {
    return value ? (
      <div className="modal-author">
        Time Duration: {value?.days} days {value?.hours} hours {value?.minutes}{' '}
        minutes
      </div>
    ) : null;
  };

  const DescText = ({ value }: { value?: string }) => {
    return <div className="modal-description">{value}</div>;
  };

  const DisplayInfo = ({ item }: any) => {
    return (
      <div className="modal-display-info">
        <DateText value={item?.updatedTime} />
        <TitleText value={item?.activityStatus} />
        <AuthorText name={item?.userName} role={item?.userRole} />
        <TimeDuration value={item?.durationTime} />
        <DescText value={item?.remarks} />
      </div>
    );
  };
  return (
    <div className="modal-container">
      {id && (
        <ActionField
          name="fetchActivityLog"
          onResponseData={(res: any) => {
            const { requestId, ...main } = res;
            const data = values(main) as any;
            setActivityLogData?.(data);
          }}
          request={{
            name: 'activityLog',
            method: 'GET',
            url: APIS.ACTIVITY_LOG,
            nextParams: (nextProps: any) => {
              return {
                id: id || '',
              };
            },
          }}
        >
          {(activityLogProps: any) => {
            const handleClick = () => {
              activityLogProps?.submitData({ id: id }, true);
            };
            return (
              <>
                <Button
                  type="primary"
                  size="small"
                  onClick={() => {
                    setShowActivityLog(true);
                    handleClick();
                  }}
                  className="btn-activity-log"
                >
                  <Icon icon="clock" />
                  &nbsp; Activity Log
                </Button>

                <Modal
                  bodyStyle={{ width: '80%' }}
                  visible={showActivityLog}
                  title="Activity Log"
                  footer={null}
                  onCancel={handleCancel}
                >
                  {activityLogData &&
                    activityLogData?.map((item: any, index: any) => {
                      return (
                        <DisplayInfo
                          key={`${index}${item?.updatedTime}`}
                          item={item}
                        />
                      );
                    })}
                </Modal>
              </>
            );
          }}
        </ActionField>
      )}
    </div>
  );
};

export default ActivityLog;
